import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/document-redactor")({
  staticData: {
    title: "Document Redactor",
  },
  head: () => ({
    meta: [
      {
        name: "description",
        content:
          "Redact names, IDs, and trade secrets in documents with Polygraf AI’s Document Redactor AI-powered, context-aware masking that preserves readability and audit trails.",
      },
    ],
  }),
});
